// MIT License - Copyright (c) 2026 Doug McNall - See .kiro/steering/general/development-standards.md for full license

/**
 * Star Trek Universe - Aliens Configuration
 */

export const StarTrekAliensPlanets = {
  planets: {
    1900: ['humanstarfleet', 'vulcans'], // Earth
    1901: ['vulcans'], // Vulcan
    1902: ['klingons'], // Qo'noS
    1903: ['romulans'], // Romulus
    1904: ['andorians'], // Andoria
    1905: ['ferengi'], // Ferenginar
    1906: ['bajorans'], // Bajor
    1907: ['cardassians'], // Cardassia Prime
    1908: ['betazoids'], // Betazed
    1909: ['humanstarfleet'], // Risa
    1910: ['ferengi', 'bajorans'], // Deep Space Nine
    1911: ['borg'] // Borg Cube Wreckage
  },
  randomEncounters: ['vulcans', 'klingons', 'borg'],
  hostileSpecies: ['borg', 'romulans', 'cardassians'],
  friendlyTraders: ['ferengi', 'humanstarfleet']
};

export default StarTrekAliensPlanets;
